import IconMoon from './selection'

export const fontAwesomeIcons = Object.freeze([
  'FaCaretRight',
  'FaCaretLeft',
  'FaCaretDown',
  'FaCaretUp',
  'FaChevronUp',
  'FaChevronDown',
  'FaChevronRight',
  'FaAngleLeft',
  'FaArrowDown',
  'FaArrowUp',
  'FaExclamationTriangle',
  'FaTimesCircle',
  'FaExpand',
  'FaCompress',
  'FaLock',
  'FaStar',
  'FaCheck',
  'FaCheckSquare',
  'FaSquareO',
  'FaClose',
  'FaCircle',
  'FaMinus',
  'FaInfoCircle',
  'FaGripVertical',
  'FaTrashAlt',
])

export const antdIcons = [
  'close',
  'edit',
  'plus',
  'check',
  'copy',
  'left',
  'right',
  'question-circle',
  'exclamation-circle',
  'info-circle',
  'plus-circle',
  'check-circle',
  'loading',
  'menu',
  'redo',
  'hourglass',
  'search',
]

export const checIcons = [
  'email',
  'help',
  'user',
  'share',
  'copy',
  'link',
  'unlink',
  'clock',
  'truck',
  'filetext',
  'pin',
  'info',
  'info-black',
  'chec_logo_color',
  'common-node',
  'common-node-hovered',
  'star-default',
  'star-hover',
  'star-selected',
  'expand',
  'collapse',
  'eye',
  'timer',
]

export const iconMoon = Object.freeze(Object.keys(IconMoon))

export default Object.freeze([
  ...fontAwesomeIcons,
  ...antdIcons,
  ...checIcons,
  ...iconMoon,
  'remove',
])

const isOfType = (typeArray) => {
  const set = new Set(typeArray)
  return (iconType) => set.has(iconType)
}

export const isFontAwesomeIcon = isOfType(fontAwesomeIcons)
export const isAntdIcon = isOfType(antdIcons)
export const isChecIcon = isOfType(checIcons)
export const isIconMoon = isOfType(iconMoon)
